import React, { useState , useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Individual.css";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
import Overview from "./Overview";

const Travelinsurance = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    emailId: "",
    dateOfBirth: "",
    city: "",
    PurposeofVisit: "",
    smoker: "",
    lifes: "",
    numberOfAdults: "1",
    numberOfChildren: "0",
    coverageAmount: "500000",
    termsAccepted: false,
  });

  const [validated, setValidated] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const resetForm = () => {
    setFormData({
      fullName: "",
      mobileNumber: "",
      emailId: "",
      dateOfBirth: "",
      city: "",
      PurposeofVisit: "",
      smoker: "",
      lifes: "",
      numberOfAdults: "1",
      numberOfChildren: "0",
      coverageAmount: "500000",
      termsAccepted: false,
    });
    setValidated(false);
    setShowSuccess(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      try {
        const response = await fetch("https://your-api-url.com/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        console.log("Form data submitted successfully:", formData);
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          resetForm();
        }, 3000);
      } catch (error) {
        console.error("Error submitting form data:", error);
      }
    }
    setValidated(true);
  };
  const insurances = ["HDFC"];
  const gender = ["Others", "Male", "Female"];

  const cities = [
    "Bangalore",
    "Mumbai",
    "Delhi",
    "Chennai",
    "Hyderabad",
    "Kolkata",
    "Pune",
  ];
  const PurposeofVisit = ["Studies", "Leisure", "Business"];
  const selectfamily = [
    "Me",
    "My Spouce",
    "My Son",
    "My Father ",
    "My mother",
    "Others",
  ];
  const coverageAmounts = [
    { value: "300000", display: "₹3,00,000" },
    { value: "500000", display: "₹5,00,000" },
    { value: "1000000", display: "₹10,00,000" },
    { value: "2000000", display: "₹20,00,000" },
    { value: "5000000", display: "₹50,00,000" },
  ];
  const travel = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo (Congo-Brazzaville)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic (Czechia)",
    "Democratic Republic of the Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar (formerly Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine State",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States of America",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];

  return (
    <>
      <Navbar />
      <div className="main-box">
        <div className="row mb-4">
          <div className="main-box-ss">
            <div className="col-12 col-md-12">
              <section className="insurance-service position-relative overflow-hidden">
                <div className="radial-bg"></div>

                <div
                  className="insurance position-relative"
                  style={{ zIndex: 1 }}
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-12 d-flex justify-content-end pt-3 px-3 px-md-5"></div>
                    </div>

                    <div
                      className="row justify-content-center align-items-center text-center"
                    >
                      <div className="col-12 mb-3 mt-5 pb-0">
                        <h2 className="fw-bold carloan-text-1 mb-2">
                          Travel Insurance
                        </h2>
                        <p className="mb-0">
                          Please fill all the details Travel Insurance
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="position-absolute top-0 start-0 w-100 h-100"
                  style={{
                    filter: "blur(88px)",
                    zIndex: 0,
                  }}
                ></div>

                <div className="container mt-5 mt-lg-0">
                  <div className="row justify-content-center">
                    <div className="col-12 col-lg-12">
                      <div className="card card_top border-0 ">
                        <div
                          className="card-body   bg-light"
                          style={{
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                            borderBottomLeftRadius: "10px",
                            borderBottomRightRadius: "10px",
                          }}
                        >
                          {showSuccess && (
                            <div className="alert alert-success" role="alert">
                              Your health insurance application has been
                              submitted successfully!
                            </div>
                          )}

                          <form
                            className={validated ? "was-validated" : ""}
                            noValidate
                            validated={validated}
                            onSubmit={handleSubmit}
                          >
                            <div className="card mb-4 ">
                              <div className="card-body">
                                <h5 className="mb-4">Personal Details</h5>
                                <div className="row">
                                  <div className="col-12 col-md-6 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="fullName">
                                        Full Name
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="fullName"
                                        name="fullName"
                                        placeholder="Enter full name"
                                        value={formData.fullName}
                                        onChange={handleChange}
                                        required
                                      />
                                      <div className="invalid-feedback">
                                        Please provide your full name.
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="mobileNumber">
                                        Mobile Number
                                      </label>
                                      <input
                                        type="tel"
                                        className="form-control"
                                        id="mobileNumber"
                                        name="mobileNumber"
                                        placeholder="Enter mobile number"
                                        value={formData.mobileNumber}
                                        onChange={handleChange}
                                        pattern="[0-9]{10}"
                                        required
                                      />
                                      <div className="invalid-feedback">
                                        Please provide a valid 10-digit mobile
                                        number.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-12 col-md-6 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="emailId">
                                        Email Address
                                      </label>
                                      <input
                                        type="email"
                                        className="form-control"
                                        id="emailId"
                                        name="emailId"
                                        placeholder="Enter email address"
                                        value={formData.emailId}
                                        onChange={handleChange}
                                        required
                                      />
                                      <div className="invalid-feedback">
                                        Please provide a valid email address.
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="dateOfBirth">
                                        Date of Birth
                                      </label>
                                      <input
                                        type="date"
                                        className="form-control"
                                        id="dateOfBirth"
                                        name="dateOfBirth"
                                        value={formData.dateOfBirth}
                                        onChange={handleChange}
                                        required
                                      />
                                      <div className="invalid-feedback">
                                        Please provide your date of birth.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-12 col-md-3 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="city">
                                        City of Residence
                                      </label>
                                      <select
                                        className="form-select"
                                        id="city"
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                        required
                                      >
                                        <option value="">Select</option>
                                        {cities.map((city, idx) => (
                                          <option key={idx} value={city}>
                                            {city}
                                          </option>
                                        ))}
                                      </select>
                                      <div className="invalid-feedback">
                                        Please select your city of residence.
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-3 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="insurance">
                                        Insurance Type
                                      </label>
                                      <select
                                        className="form-select"
                                        id="insurance"
                                        name="insurance"
                                        value={formData.insurance}
                                        onChange={handleChange}
                                        required
                                      >
                                        <option value="">Select</option>
                                        {insurances.map((insurance, idx) => (
                                          <option key={idx} value={insurance}>
                                            {insurance}
                                          </option>
                                        ))}
                                      </select>
                                      <div className="invalid-feedback">
                                        Please select your insurance type.
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-3 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="Gender">Gender</label>
                                      <select
                                        className="form-select"
                                        id="gender"
                                        name="gender"
                                        value={formData.gender}
                                        onChange={handleChange}
                                        required
                                      >
                                        <option value="">Select</option>
                                        {gender.map((gender, idx) => (
                                          <option key={idx} value={gender}>
                                            {gender}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-3 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="selectfamily">
                                        Select Family Members
                                      </label>
                                      <select
                                        className="form-select"
                                        id="selectfamily"
                                        name="selectfamily"
                                        value={formData.selectfamily}
                                        onChange={handleChange}
                                        required
                                      >
                                        <option value="">Select</option>
                                        {selectfamily.map((family, index) => (
                                          <option key={index} value={family}>
                                            {family}
                                          </option>
                                        ))}
                                      </select>
                                      <div className="invalid-feedback">
                                        Please select your medical condition.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="card mb-4 ">
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-12 col-md-3 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="PurposeofVist">
                                        Purpose of Visit
                                      </label>
                                      <select
                                        className="form-select"
                                        id="PurposeofVisit"
                                        name="PurposeofVisit"
                                        value={formData.PurposeofVist}
                                        onChange={handleChange}
                                        required
                                      >
                                        <option value="">Select</option>
                                        {PurposeofVisit.map((visit, index) => (
                                          <option key={index} value={visit}>
                                            {visit}
                                          </option>
                                        ))}
                                      </select>
                                      <div className="invalid-feedback">
                                        Please select your medical condition.
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-3 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="Travel">Travel to</label>
                                      <select
                                        className="form-select"
                                        id="travel"
                                        name="travel"
                                        value={formData.travel}
                                        onChange={handleChange}
                                        required
                                      >
                                        <option value="">Select</option>
                                        {travel.map((travel, index) => (
                                          <option key={index} value={travel}>
                                            {travel}
                                          </option>
                                        ))}
                                      </select>
                                      <div className="invalid-feedback">
                                        Please select your medical condition.
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-3 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="dateOfBirth">
                                        Trip Start Date
                                      </label>
                                      <input
                                        type="date"
                                        className="form-control"
                                        id="dateOfBirth"
                                        name="dateOfBirth"
                                        value={formData.dateOfBirth}
                                        onChange={handleChange}
                                        required
                                      />
                                      <div className="invalid-feedback">
                                        Please provide your date of birth.
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-3 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="dateOfBirth">
                                        Trip End Date
                                      </label>
                                      <input
                                        type="date"
                                        className="form-control"
                                        id="dateOfBirth"
                                        name="dateOfBirth"
                                        value={formData.dateOfBirth}
                                        onChange={handleChange}
                                        required
                                      />
                                      <div className="invalid-feedback">
                                        Please provide your date of birth.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12">
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="termsAccepted"
                                    name="termsAccepted"
                                    checked={formData.termsAccepted}
                                    onChange={handleChange}
                                    required
                                  />
                                  <span>
                                    By submitting the application, I agree and
                                    accept the Terms and Conditions as specified{" "}
                                    <a href="/" className="text-primary">
                                      here
                                    </a>
                                  </span>
                                  <div className="invalid-feedback">
                                    You must accept the terms and conditions.
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row mt-3">
                              <div className="col-12">
                                <button
                                  type="submit"
                                  className="btn btn-primary btn-m py-2"
                                >
                                  Apply
                                </button>
                                &nbsp;&nbsp;&nbsp;
                                <button
                                  className="btn btn-primary py-2 btn-m"
                                  onClick={resetForm}
                                >
                                  Clear
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Overview />
      <Explore />
      <Footer />
    </>
  );
};

export default Travelinsurance;
